import Vue from 'vue'
import App from './App.vue'

import '@/assets/styles/reset.less'

import { isMobile } from '@/utils/env'

if (process.env.NODE_ENV !== 'production' && isMobile()) {
  import('eruda').then((eruda) => {
    eruda.default.init()
  })
}

Vue.config.productionTip = false

new Vue({
  ...App,
}).$mount('#app')
